import { TreeviewConfig } from '@laijuthomas/ngx-treeview';
import {Injectable} from '@angular/core';

@Injectable()
export class TreeviewCustomConfig extends TreeviewConfig {
  hasAllCheckBox = false;
  hasFilter = false;
  hasCollapseExpand = true;
  decoupleChildFromParent = true;
  maxHeight = 400;
}
